<template>
  <div>
    <van-tabs v-model="activeName">
      <van-tab title="未缴费订单" name="a">
        <div style="padding:10px" class="form" v-if="bankBalancePay.orderNo">
          <van-cell-group>
            <van-cell title="订单号" :value="bankBalancePay.orderNo" />
            <van-cell title="班级" :value="bankBalancePay.className" />
            <van-cell title="姓名" :value="bankBalancePay.name" />
            <van-cell title="缴费名称" :value="bankBalancePay.periodName" /> 
            <van-cell title="缴费期" :value="bankBalancePay.periodTerm" />
            <van-cell title="开始日期" :value="period.startTime" />
            <van-cell title="结束日期" :value="period.endTime" />
            <van-cell v-if="bankBalancePay.schoolFee" :title="period.type==0?'保教费':'学费'" :value="bankBalancePay.schoolFee | money" />
            <van-cell v-if="bankBalancePay.tuitionWaiver" :title="period.type==0?'学费减免':'学费减免'" :value="bankBalancePay.tuitionWaiver | money" />
            <van-cell v-if="bankBalancePay.textbookFee" title="课本费" :value="bankBalancePay.textbookFee | money" />
            <van-cell v-if="bankBalancePay.lunchFee" :title="period.type==0?'伙食费':'午餐费'" clickable >
              <template #right-icon>
                <div style="text-align:right;width:100%" v-if="period.type==0">{{bankBalancePay.lunchFee | money}}</div>
                <van-checkbox style="width:100%;display: flex;justify-content: flex-end;" v-if="period.type!=0" v-model="bankBalancePay.hasLunch" @change="toggleSumPrice()">{{bankBalancePay.lunchFee | money}}</van-checkbox>
              </template>
            </van-cell>
            <van-cell :title="period.type==0?'伙食费减免':'午餐费减免'"  v-if="period.type==0 && bankBalancePay.reduceLunch">
              <template #right-icon>
                <div style="text-align:right;width:100%" >{{bankBalancePay.reduceLunch | money}}</div>
              </template>
            </van-cell>
            <van-cell v-if="bankBalancePay.hotelFee" title="住宿费" clickable >
              <template #right-icon>
                <van-checkbox style="width:100%;display: flex;justify-content: flex-end;" v-model="bankBalancePay.hasHotel" @change="toggleSumPrice()">{{bankBalancePay.hotelFee | money}}</van-checkbox>
              </template>
            </van-cell> 
            <van-cell v-if="bankBalancePay.afterClassServiceFee" title="课后服务费" :value="bankBalancePay.afterClassServiceFee | money" />
            <van-cell title="课后服务费减免" v-if="bankBalancePay.afterClassServiceFeeWaiver" :value="bankBalancePay.afterClassServiceFeeWaiver | money" />
            <van-cell v-if="bankBalancePay.otherFee" title="其他" :value="bankBalancePay.otherFee | money" />
            <van-cell title="其他减免" v-if="bankBalancePay.otherFeeWaiver" :value="bankBalancePay.otherFeeWaiver | money" />
            <van-cell title="备注" :value="bankBalancePay.remark" />
            <van-cell title="合计" :value="bankBalancePay.totalAmount | money" />
          </van-cell-group>
          <van-button type="primary" block color="#4935ae" size="normal" style="margin-top:10px;margin-bottom:10px" @click="payOrder">支付</van-button>
          <van-button type="info" block  size="normal" style="margin-top:10px;margin-bottom:30px" @click="getData">刷新支付状态</van-button>
        </div>
        <div v-else  style="text-align:center;margin-top:20vh;color:#666">
          <div style="margin-bottom:5px"><van-icon name="description" size="40"/></div>
          您当前没有缴费订单
        </div>
      </van-tab>
      <van-tab title="已缴费订单" name="b">
        <div style="padding:10px">
          <van-collapse v-model="activeNameTab" accordion>
            <van-collapse-item v-for="item in list" :title="item.periodName+'-'+item.periodTerm" :name="item.id">
              <van-cell-group class="form">
                <van-cell title="订单号" :value="item.orderNo" />
                <van-cell title="班级" :value="item.className" />
                <van-cell title="姓名" :value="item.name" />
                <van-cell title="缴费名称" :value="item.periodName" />
                <van-cell title="缴费期" :value="item.periodTerm" />
                <van-cell :title="item.type==0?'保教费':'学费'" v-if="item.schoolFee" :value="item.schoolFee | money" />
                <van-cell :title="item.type==0?'学费减免':'学费减免'" v-if="item.tuitionWaiver" :value="item.tuitionWaiver | money" />
                <van-cell title="课本费" v-if="item.textbookFee" :value="item.textbookFee | money" />
                <van-cell :title="item.type==0?'伙食费':'午餐费'" v-if="item.lunchFee && item.hasLunch" :value="item.lunchFee | money" ></van-cell>
                <van-cell :title="item.type==0?'伙食费减免':'午餐费减免'"  v-if="item.type==0 && item.reduceLunch">
                  <template #right-icon>
                    <div style="text-align:right;width:100%" >{{item.reduceLunch | money}}</div>
                  </template>
                </van-cell>
                <van-cell title="住宿费" v-if="item.hotelFee  && item.hasHotel" :value="item.hotelFee | money" />
                <van-cell title="课后服务费" v-if="item.afterClassServiceFee" :value="item.afterClassServiceFee | money" />
                <van-cell title="课后服务费减免" v-if="item.afterClassServiceFeeWaiver" :value="item.afterClassServiceFeeWaiver | money" />
                <van-cell title="其他" v-if="item.otherFee" :value="item.otherFee | money" />
                <van-cell title="其他减免" v-if="item.otherFeeWaiver" :value="item.otherFeeWaiver | money" />
                <van-cell title="备注" :value="item.remark" />
                <van-cell title="合计" :value="item.totalAmount | money" />
                <van-cell title="支付状态" :value="getPayText(item.state)" />
                <van-cell v-if="item.refundRemark" title="状态描述" :value="item.refundRemark" />
                <van-cell title="退款描述" v-if="(item.state==3 || item.state==4 || item.state==6 || item.state==7) && item.body" :value="item.body" />
              </van-cell-group>
              <van-button type="info" block v-if="item.state!=3 && item.state!=4 && item.state!=6 && item.state!=7" size="normal" style="margin-top:10px;margin-bottom:30px" @click="createImage(item)">查看电子回执单</van-button>
            </van-collapse-item>
          </van-collapse>
          <van-button type="info" block  size="normal" style="margin-top:10px;margin-bottom:30px" @click="getData">刷新缴费订单</van-button>
        </div>
        <div style="opacity: 0;position: fixed;z-index: -1;background-color:#FFF;top:0px;left:0px;" v-if="showTmp">
        <!-- <div> -->
          <div id="order">
            <div class="main" style="background-color:#FFF;">
              <div class="body">
                <div class="title">
                  <div class="div1">
                    <div class="divCtn">
                      <div class="titleCtn">{{selectItem.schoolName}}</div>
                      <div class="titleUdeLine"></div>
                    </div>
                  </div>
                  <div class="div2" style="text-align:right">NO：<span style="color: #9C5223;">{{selectItem.orderNo}}</span></div>
                </div>
                <div class="date">
                  <div style="flex:1">&nbsp;</div>
                  <div style="flex:1;font-size:18px;text-align:center;padding-right: 62px;line-height: 40px;">缴费凭证</div>
                  <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                  <div style="flex:1" class="deDiv1">{{moment(selectItem.payTime).format("YYYY")}}年{{moment(selectItem.payTime).format("MM")}}月{{moment(selectItem.payTime).format("DD")}}日</div>
                </div>
                <table border="0" style="width: 100%;border:1px solid #000; border-collapse: collapse;">
                  <tr>
                    <td align="center" rowspan="2" style="width: 20%;">学生信息</td>
                    <td align="center" rowspan="2" style="width: 50%;text-align:left">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span style="display:inline-block">{{selectItem.name}}</span>
                      <span style="display:inline-block;padding-left:80px">{{selectItem.className}}</span>
                    </td>
                    <td colspan="10"  align="center" style="width: 20%;">金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额</td>
                  </tr>
                  <tr class="tempTr1">
                    <td>百</td>
                    <td>十</td>
                    <td>万</td>
                    <td>千</td>
                    <td>百</td>
                    <td>十</td>
                    <td>元</td>
                    <td>角</td>
                    <td>分</td>
                  </tr>
                  <tr class="tempTr2">
                    <td :rowspan="detailTexts.length+1">缴费项目</td>
                  </tr>
                  <tr class="tempTr2" v-for="(text,tIndex) in detailTexts">
                    <td style="text-align:left;    border: 0;">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{text}}
                    </td>
                    
                    <td class="money-td"><span>{{detailVals[tIndex].length>9?detailVals[tIndex][detailVals[tIndex].length-10]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>8?detailVals[tIndex][detailVals[tIndex].length-9]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>7?detailVals[tIndex][detailVals[tIndex].length-8]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>6?detailVals[tIndex][detailVals[tIndex].length-7]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>5?detailVals[tIndex][detailVals[tIndex].length-6]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>4?detailVals[tIndex][detailVals[tIndex].length-5]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>3?detailVals[tIndex][detailVals[tIndex].length-4]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>1?detailVals[tIndex][detailVals[tIndex].length-2]:''}}</span></td>
                    <td class="money-td"><span>{{detailVals[tIndex].length>0?detailVals[tIndex][detailVals[tIndex].length-1]:''}}</span></td>
                  </tr>
                  <tr class="tempTr2">
                    <td align="center"  colspan="1" >人民币(大写)</td>
                    <td  style=" text-align: left;">
                      {{NumberToChinese(selectItem.totalAmount)}}
                    </td>
                    <td align="center" colspan="10"  style="text-align:right">￥{{selectItem.totalAmount | money}}</td>
                  </tr>
                </table>
                <div style="width: 100%; display: flex; height: 40px;padding-left:50px;padding-top:10px">
                  缴费期：{{selectItem.periodTerm}}
                </div>
                <img v-if="selectItem.schoolName=='西安锦园中学'" src="./xajyzx.png" style="position: absolute;bottom: 50px;right: 190px;width: 120px;height: 120px;border-radius: 50%;z-inde:1">
                <img v-if="selectItem.schoolName=='西安瑞朗幼儿园有限责任公司'" src="./xarlyey.png" style="position: absolute;bottom: 50px;right: 190px;width: 120px;height: 120px;border-radius: 50%;z-inde:1">
                <img v-if="selectItem.schoolName=='陕西师范大学锦园幼儿园'" src="./xawysxsfdxjyyey.png" style="position: absolute;bottom: 50px;right: 190px;width: 120px;height: 120px;border-radius: 50%;z-inde:1">
                <img v-if="selectItem.schoolName=='西安未央锦园小学'" src="./xawyjyxx.png" style="position: absolute;bottom: 50px;right: 190px;width: 120px;height: 120px;border-radius: 50%;z-inde:1">
              </div>
            </div>
          </div>
        </div>
        <van-dialog v-model="showImg" title="长按图片保存到相册" >
          <div style="text-align:center;margin: 20px 0px;">
            <viewer><img :src="imgsrc" style="width:90%"></viewer>
          </div>
        </van-dialog>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { Toast } from 'vant';
import domtoimage from 'dom-to-image'
export default {
  data() {
    return {
      form: {},
      selectItem:{},
      activeName: 'b',
      current:"",
      bankBalancePay:{},
      oldBankBalancePay:{},
      cardNo: "",
      numCount:0,
      openUnbundling: false,
      show:false,
      linker:'',
      phone:'',
      address:'',
      supplierName:"",
      list:[],
      loading: false,
      finished: false,
      refreshing: false,
      currentPage:1,
      activeNameTab:'',
      payStates:[],
      setting:{},
      period:{},
      showTmp:false,
      showImg:false,
      imgsrc:'',
      printSumAmount:0,
      detailTexts:[],
      detailVals:[],
      unit: new Array("仟", "佰", "拾", "", "仟", "佰", "拾", "", "角", "分"),
    };
  },
  components: {},
  created() {
    if(this.$route.query.token){
      window.localStorage.setItem("token",this.$route.query.token)
    }
    this.getData();
    
  },
  methods: {
    toDx(n) {   //阿拉伯数字转换函数
        switch (n) {
            case "0":
                return "零";
            case "1":
                return "壹";
            case "2":
                return "贰";
            case "3":
                return "叁";
            case "4":
                return "肆";
            case "5":
                return "伍";
            case "6":
                return "陆";
            case "7":
                return "柒";
            case "8":
                return "捌";
            case "9":
                return "玖";
        }
    },
    NumberToChinese(m){
        m *= 100;
        m += "";
        var length = m.length;

        var result = "";
        for (var i = 0; i < length; i++) {
            if (i == 2) {
                result = "元" + result;
            } else if (i == 6) {
                result = "万" + result;
            }
            if (m.charAt(length - i - 1) == 0) {
                if (i != 0 && i != 1) {
                    if (result.charAt(0) != '零' && result.charAt(0) != '元' && result.charAt(0) != '万') {
                        result = "零" + result;
                    }
                }
                continue;
            }
            result = this.toDx(m.charAt(length - i - 1)) + this.unit[this.unit.length - i - 1] + result;
        }
        result += result.charAt(result.length - 1) == '元' ? "整" : "";
        return result;
    },
    toggleSumPrice(){
      let sumPrice=0
      sumPrice=sumPrice+(this.bankBalancePay.schoolFee?this.bankBalancePay.schoolFee:0)*1
      sumPrice=sumPrice+(this.bankBalancePay.tuitionWaiver?this.bankBalancePay.tuitionWaiver:0)*1
      sumPrice=sumPrice+(this.bankBalancePay.textbookFee?this.bankBalancePay.textbookFee:0)*1
      if(this.bankBalancePay.lunchFee){
        if(this.bankBalancePay.hasLunch){
          sumPrice=sumPrice+this.bankBalancePay.lunchFee*1
        }
      }
      sumPrice=sumPrice+(this.bankBalancePay.reduceLunch?this.bankBalancePay.reduceLunch:0)*1
      if(this.bankBalancePay.hotelFee){
        if(this.bankBalancePay.hasHotel){
          sumPrice=sumPrice+this.bankBalancePay.hotelFee*1
        }
      }
      sumPrice=sumPrice+(this.bankBalancePay.afterClassServiceFee?this.bankBalancePay.afterClassServiceFee:0)*1
      sumPrice=sumPrice+(this.bankBalancePay.afterClassServiceFeeWaiver?this.bankBalancePay.afterClassServiceFeeWaiver:0)*1
      sumPrice=sumPrice+(this.bankBalancePay.otherFee?this.bankBalancePay.otherFee:0)*1
      sumPrice=sumPrice+(this.bankBalancePay.otherFeeWaiver?this.bankBalancePay.otherFeeWaiver:0)*1
      this.bankBalancePay.totalAmount=sumPrice
    },
    getPayText(key){
      let data=this.payStates.find(item=>{
        return key==item.index
      })
      return data.name
    },
    createImage(item){
      this.selectItem=item
      if(this.selectItem.schoolName == '西安市未央区陕西师范大学锦园幼儿园'){
        this.selectItem.schoolName = '陕西师范大学锦园幼儿园'
      }
      this.detailTexts=[]
      this.detailVals=[]
      if(this.selectItem.schoolFee){
        this.detailTexts.push(this.selectItem.type==0?'保教费':'学费')
        this.detailVals.push((this.selectItem.schoolFee).toFixed(2))
      }
      if(this.selectItem.tuitionWaiver){
        this.detailTexts.push(this.selectItem.type==0?'学费减免（-）':'学费减免（-）')
        this.detailVals.push((this.selectItem.tuitionWaiver).toFixed(2))
      }
      if(this.selectItem.textbookFee){
        this.detailTexts.push('课本费')
        this.detailVals.push((this.selectItem.textbookFee).toFixed(2))
      }
      if(this.selectItem.lunchFee && this.selectItem.hasLunch){
        this.detailTexts.push(this.selectItem.type==0?'伙食费':'午餐费')
        this.detailVals.push((this.selectItem.lunchFee).toFixed(2))
      }
      if(this.selectItem.type==0 && this.selectItem.reduceLunch){
        this.detailTexts.push(this.selectItem.type==0?'伙食费减免（-）':'午餐费减免（-）')
        this.detailVals.push((this.selectItem.reduceLunch).toFixed(2))
      }
      if(this.selectItem.hasHotel && this.selectItem.hotelFee){
        this.detailTexts.push('住宿费')
        this.detailVals.push((this.selectItem.hotelFee).toFixed(2))
      }
      if(this.selectItem.afterClassServiceFee){
        this.detailTexts.push('课后服务费')
        this.detailVals.push((this.selectItem.afterClassServiceFee).toFixed(2))
      }
      if(this.selectItem.afterClassServiceFeeWaiver){
        this.detailTexts.push('课后服务费减免')
        this.detailVals.push((this.selectItem.afterClassServiceFeeWaiver).toFixed(2))
      }
      if(this.selectItem.otherFee){
        this.detailTexts.push('其他费用')
        this.detailVals.push((this.selectItem.otherFee).toFixed(2))
      }
      if(this.selectItem.otherFeeWaiver){
        this.detailTexts.push('其他费用减免')
        this.detailVals.push((this.selectItem.otherFeeWaiver).toFixed(2))
      }
      this.printSumAmount=(item.totalAmount*1).toFixed(2)
      this.showTmp=true
      this.$nextTick(()=>{
        let node = document.getElementById('order');
        let that = this
        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '生成中...',
        });
        that.imgsrc=''
        domtoimage.toPng(node)
        .then(function (dataUrl) {
            Toast.clear();
            that.imgsrc = dataUrl
            that.showTmp=false
            that.showImg=true
        })
        .catch(function (error) {
          Toast.clear();
            console.error('生成失败', error);
        });
      })
    },
    filterTag(node) {
      console.log(node, node.tagName)
      return node.tagName == 'IMG'
    },
    payOrder(){
      if(!this.moment(this.current).isSameOrAfter(this.period.startTime)){
        this.$toast.fail("缴费期未开始")
        return;
      }
      if(!this.moment(this.period.endTime).isSameOrAfter(this.current)){
        this.$toast.fail("缴费期已结束")
        return;
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '请稍候...',
      });
      this.$request.get("payOrders/initPayRequest",{"payId":this.bankBalancePay.id,hasHotel:this.bankBalancePay.hasHotel,hasLunch:this.bankBalancePay.hasLunch}).then(data=>{
        Toast.clear();
        if(data.status==200 && data.content && data.content.url){
          window.location.href=data.content.url
          // this.router.push({path:'/web',query:{url:window.encodeURIComponent(data.content.url)}})
        }else{
          Toast.clear();
          this.$toast.fail(data.message)
        }
      })
    },
    onLoad(){
      this.currentPage++
      this.loading=true
      this.getData()
    },
     getData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '请稍候...',
      });
      this.$request.get("payOrders/getNoPayOrder").then(data=>{
        Toast.clear();
        if(data.status==200 && data.content.bankBalancePay && data.content.bankBalancePay.orderNo){
          this.current=this.moment(data.content.current).format("YYYY-MM-DD HH:mm:ss")
          this.oldBankBalancePay=data.content.bankBalancePay
          this.bankBalancePay=data.content.bankBalancePay
          this.period=data.content.period
          this.activeName='a'
          this.$request.get("payOrders/getHistoryPayRecords",{"page.pn":this.currentPage,"page.size":1000}).then(data=>{
            if(data.status==200){
              this.payStates=data.content.payStates
              this.list=data.content.content
            }
          })
        }else{
          this.activeName='b'
        }
      })
      this.$request.get("payOrders/getHistoryPayRecords",{"page.pn":this.currentPage,"page.size":1000}).then(data=>{
        if(data.status==200){
          this.payStates=data.content.payStates
          this.list=data.content.content
        }
      })
    },
  }
};
</script>

<style>
.merchant-info{
  display: inline-block;
  width: 60px;
  height: 60px;
  color: #4935ae;
  text-align: center;
  line-height: 60px;
  margin-top:10px;
  margin-left: 30px;
  font-size: 26px;
}
.label-class{
  color:#888;
  font-size:14px;
  text-align: left;
}
.main{width: 850px; margin: 0px auto; margin-top: 20px; padding: 20px; display: flex;}
.body{width: 95%; margin: 0px auto;position: relative;}
.title{width: 100%; height: 40px; display: flex;}
.title .div1{width: 60%; display: flex; justify-content: flex-end;}
.title .div1 .divCtn{min-width: 230px; height: 40px; float: right;}
.title .div1 .divCtn .titleCtn{min-width: 230px; height: 30px; line-height: 30px;text-align: center; font-size: 20px; font-weight: bold;}
.title .div1 .divCtn .titleUdeLine{min-width: 230px; height: 6px; border-bottom: solid 2px #9C5223; border-top: solid 2px #9C5223;}
.title .div2{width: 40%; text-align: right; height: 40px; line-height: 30px; font-size: 18px; font-weight: bold;}
.date{width: 100%; height: 40px; display: flex;}
.date .deDiv1{padding-right:20px; height: 40px; line-height: 40px; text-align: right; font-size: 18px;}
.date .deDiv2{width: 40%; height: 40px;line-height: 40px;  text-align: right;font-size: 18px;}
.tempTr1 td{text-align: center;}
table tr td{padding: 5px;border:1px solid #000}
.tempTr2 td{height: 40px; text-align: center;}
.end{width: 5%; height: 480px; }
.money-td{
  position: relative;
}
.money-td span{
  position: absolute;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/tabs/index.vue